module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 1);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "default", function () {
    return f;
  });
  var r = n(0),
      o = n.n(r);
  n(2);

  function i(t) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function s(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function a(t) {
    return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function c(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function l(t, e) {
    return (l = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function u(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var f = function (t) {
    function e(t) {
      var n, r, s;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), r = this, s = a(e).call(this, t), n = !s || "object" !== i(s) && "function" != typeof s ? c(r) : s, u(c(n), "toggle", function (t) {
        n.state.checked ? n.off() : n.on();
      }), u(c(n), "off", function () {
        n.state.disabled || (n.setState({
          checked: !1
        }), n.props.onChange && n.props.onChange(!1));
      }), u(c(n), "on", function () {
        n.state.disabled || (n.setState({
          checked: !0
        }), n.props.onChange && n.props.onChange(!0));
      }), u(c(n), "enable", function () {
        n.setState({
          disabled: !1
        });
      }), u(c(n), "disable", function () {
        n.setState({
          disabled: !0
        });
      }), u(c(n), "render", function () {
        var t = {};
        n.state.width && (t.width = n.state.width + "px"), n.state.height && (t.height = n.state.height + "px");
        var e = {};
        return n.state.height && (e.lineHeight = "calc(" + n.state.height + "px * 0.8)"), o.a.createElement("div", {
          className: "switch btn " + (n.state.checked ? "on btn-" + n.state.onstyle : "off btn-" + n.state.offstyle) + (n.state.size ? " btn-" + n.state.size : "") + (n.state.style ? " " + n.state.style : ""),
          style: t,
          onClick: n.toggle
        }, o.a.createElement("div", {
          className: "switch-group"
        }, o.a.createElement("span", {
          className: "switch-on btn btn-" + n.state.onstyle + (n.state.size ? " btn-" + n.state.size : ""),
          style: e
        }, n.state.onlabel), o.a.createElement("span", {
          className: "switch-off btn btn-" + n.state.offstyle + (n.state.size ? " btn-" + n.state.size : ""),
          style: e
        }, n.state.offlabel), o.a.createElement("span", {
          className: "switch-handle btn btn-light" + (n.state.size ? "btn-" + n.state.size : "")
        })));
      }), n.state = {
        checked: "boolean" == typeof n.props.checked && n.props.checked,
        disabled: "boolean" == typeof n.props.disabled && n.props.disabled,
        onlabel: n.props.onlabel || "On",
        offlabel: n.props.offlabel || "Off",
        onstyle: n.props.onstyle || "primary",
        offstyle: n.props.offstyle || "light",
        size: n.props.size || "",
        style: n.props.style || "",
        width: n.props.width || null,
        height: n.props.height || null
      }, n;
    }

    var n, r, f;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && l(t, e);
    }(e, t), n = e, (r = [{
      key: "componentDidUpdate",
      value: function value(t, e) {
        var n = this.props.checked;
        "boolean" == typeof n && n !== e.checked && this.setState({
          checked: n
        });
      }
    }]) && s(n.prototype, r), f && s(n, f), e;
  }(o.a.Component);
}, function (t, e, n) {
  var r = n(3);
  "string" == typeof r && (r = [[t.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(5)(r, o);
  r.locals && (t.exports = r.locals);
}, function (t, e, n) {
  (t.exports = n(4)(!1)).push([t.i, '/*\\\n|*|  :: Bootstrap Switch Button ::\n|*|\n|*|  Bootstrap Switch Button (React)\n|*|  https://github.com/gitbrent/bootstrap-switch-button-react\n|*|\n|*|  This library is released under the MIT Public License (MIT)\n|*|\n|*|  Bootstrap Switch Button (C) 2019-present Brent Ely (https://github.com/gitbrent)\n|*|\n|*|  Permission is hereby granted, free of charge, to any person obtaining a copy\n|*|  of this software and associated documentation files (the "Software"), to deal\n|*|  in the Software without restriction, including without limitation the rights\n|*|  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n|*|  copies of the Software, and to permit persons to whom the Software is\n|*|  furnished to do so, subject to the following conditions:\n|*|\n|*|  The above copyright notice and this permission notice shall be included in all\n|*|  copies or substantial portions of the Software.\n|*|\n|*|  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n|*|  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n|*|  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n|*|  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n|*|  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n|*|  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\n|*|  SOFTWARE.\n\\*/\n\n.btn-group-xs > .btn, .btn-xs {\n\tpadding: .35rem .4rem .25rem .4rem;\n\tfont-size: .875rem;\n\tline-height: .5;\n\tborder-radius: .2rem;\n}\n\n.switch {\n\tposition: relative;\n\toverflow: hidden;\n}\n.switch.btn.btn-light, .switch.btn.btn-outline-light {\n\tborder-color: rgba(0, 0, 0, .15); /* Add a border so switch is delineated */\n}\n.switch input[type="checkbox"] {\n\tdisplay: none;\n}\n.switch-group {\n\tposition: absolute;\n\twidth: 200%;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\ttransition: left 0.35s;\n\t-webkit-transition: left 0.35s;\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n}\n.switch.off .switch-group {\n\tleft: -100%;\n}\n.switch-on {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 50%;\n\tmargin: 0;\n\tborder: 0;\n\tborder-radius: 0;\n}\n.switch-off {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 50%;\n\tright: 0;\n\tmargin: 0;\n\tborder: 0;\n\tborder-radius: 0;\n\tbox-shadow: none;\n}\n.switch-handle {\n\tposition: relative;\n\tmargin: 0 auto;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n\theight: 100%;\n\twidth: 0px;\n\tborder-width: 0 1px;\n\tbackground-color: #fff;\n}\n\n.switch.btn-outline-primary .switch-handle {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n.switch.btn-outline-secondary .switch-handle {\n\tbackground-color: var(--secondary);\n\tborder-color: var(--secondary);\n}\n.switch.btn-outline-success .switch-handle {\n\tbackground-color: var(--success);\n\tborder-color: var(--success);\n}\n.switch.btn-outline-danger .switch-handle {\n\tbackground-color: var(--danger);\n\tborder-color: var(--danger);\n}\n.switch.btn-outline-warning .switch-handle {\n\tbackground-color: var(--warning);\n\tborder-color: var(--warning);\n}\n.switch.btn-outline-info .switch-handle {\n\tbackground-color: var(--info);\n\tborder-color: var(--info);\n}\n.switch.btn-outline-light .switch-handle {\n\tbackground-color: var(--light);\n\tborder-color: var(--light);\n}\n.switch.btn-outline-dark .switch-handle {\n\tbackground-color: var(--dark);\n\tborder-color: var(--dark);\n}\n.switch[class*="btn-outline"]:hover .switch-handle {\n\tbackground-color: var(--light);\n\topacity: 0.5;\n}\n\n/* NOTE: Must come first, so classes below override as needed */\n/* bootstrap-4.x .form-control {height} values used as `min-height` to mirror output sizes */\n\n.switch.btn { min-width: 3.7rem; min-height: calc(1.5em + .75rem + 2px); }\n.switch-on.btn { padding-right: 1.5rem; }\n.switch-off.btn { padding-left: 1.5rem; }\n\n.switch.btn-lg { min-width: 5rem; line-height: 1.5; min-height: calc(1.5em + 1rem + 2px); }\n.switch-on.btn-lg { padding-right: 2rem; }\n.switch-off.btn-lg { padding-left: 2rem; }\n.switch-handle.btn-lg { width: 2.5rem; }\n\n.switch.btn-sm { min-width: 3.25rem; min-height: calc(1.5em + .5rem + 2px); }\n.switch-on.btn-sm { padding-right: 1rem; }\n.switch-off.btn-sm { padding-left: 1rem; }\n\n/* `xs` (bootstrap-3.3 - .btn - h:22px) */\n.switch.btn-xs { min-width: 3.125rem; min-height: 1.375rem; }\n.switch-on.btn-xs { padding-right: .8rem; }\n.switch-off.btn-xs { padding-left: .8rem; }\n', ""]);
}, function (t, e, n) {
  "use strict";

  t.exports = function (t) {
    var e = [];
    return e.toString = function () {
      return this.map(function (e) {
        var n = function (t, e) {
          var n = t[1] || "",
              r = t[3];
          if (!r) return n;

          if (e && "function" == typeof btoa) {
            var o = (s = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(s)))) + " */"),
                i = r.sources.map(function (t) {
              return "/*# sourceURL=" + r.sourceRoot + t + " */";
            });
            return [n].concat(i).concat([o]).join("\n");
          }

          var s;
          return [n].join("\n");
        }(e, t);

        return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
      }).join("");
    }, e.i = function (t, n) {
      "string" == typeof t && (t = [[null, t, ""]]);

      for (var r = {}, o = 0; o < this.length; o++) {
        var i = this[o][0];
        null != i && (r[i] = !0);
      }

      for (o = 0; o < t.length; o++) {
        var s = t[o];
        null != s[0] && r[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), e.push(s));
      }
    }, e;
  };
}, function (t, e, n) {
  var r,
      o,
      i = {},
      s = (r = function r() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = r.apply(this, arguments)), o;
  }),
      a = function a(t, e) {
    return e ? e.querySelector(t) : document.querySelector(t);
  },
      c = function (t) {
    var e = {};
    return function (t, n) {
      if ("function" == typeof t) return t();

      if (void 0 === e[t]) {
        var r = a.call(this, t, n);
        if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
          r = r.contentDocument.head;
        } catch (t) {
          r = null;
        }
        e[t] = r;
      }

      return e[t];
    };
  }(),
      l = null,
      u = 0,
      f = [],
      d = n(6);

  function p(t, e) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n],
          o = i[r.id];

      if (o) {
        o.refs++;

        for (var s = 0; s < o.parts.length; s++) {
          o.parts[s](r.parts[s]);
        }

        for (; s < r.parts.length; s++) {
          o.parts.push(y(r.parts[s], e));
        }
      } else {
        var a = [];

        for (s = 0; s < r.parts.length; s++) {
          a.push(y(r.parts[s], e));
        }

        i[r.id] = {
          id: r.id,
          refs: 1,
          parts: a
        };
      }
    }
  }

  function h(t, e) {
    for (var n = [], r = {}, o = 0; o < t.length; o++) {
      var i = t[o],
          s = e.base ? i[0] + e.base : i[0],
          a = {
        css: i[1],
        media: i[2],
        sourceMap: i[3]
      };
      r[s] ? r[s].parts.push(a) : n.push(r[s] = {
        id: s,
        parts: [a]
      });
    }

    return n;
  }

  function b(t, e) {
    var n = c(t.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = f[f.length - 1];
    if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), f.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
      if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = c(t.insertAt.before, n);
      n.insertBefore(e, o);
    }
  }

  function m(t) {
    if (null === t.parentNode) return !1;
    t.parentNode.removeChild(t);
    var e = f.indexOf(t);
    e >= 0 && f.splice(e, 1);
  }

  function g(t) {
    var e = document.createElement("style");

    if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
      var r = function () {
        0;
        return n.nc;
      }();

      r && (t.attrs.nonce = r);
    }

    return w(e, t.attrs), b(t, e), e;
  }

  function w(t, e) {
    Object.keys(e).forEach(function (n) {
      t.setAttribute(n, e[n]);
    });
  }

  function y(t, e) {
    var n, r, o, i;

    if (e.transform && t.css) {
      if (!(i = "function" == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))) return function () {};
      t.css = i;
    }

    if (e.singleton) {
      var s = u++;
      n = l || (l = g(e)), r = S.bind(null, n, s, !1), o = S.bind(null, n, s, !0);
    } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
      var e = document.createElement("link");
      return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", w(e, t.attrs), b(t, e), e;
    }(e), r = E.bind(null, n, e), o = function o() {
      m(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = g(e), r = T.bind(null, n), o = function o() {
      m(n);
    });

    return r(t), function (e) {
      if (e) {
        if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
        r(t = e);
      } else o();
    };
  }

  t.exports = function (t, e) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = s()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
    var n = h(t, e);
    return p(n, e), function (t) {
      for (var r = [], o = 0; o < n.length; o++) {
        var s = n[o];
        (a = i[s.id]).refs--, r.push(a);
      }

      t && p(h(t, e), e);

      for (o = 0; o < r.length; o++) {
        var a;

        if (0 === (a = r[o]).refs) {
          for (var c = 0; c < a.parts.length; c++) {
            a.parts[c]();
          }

          delete i[a.id];
        }
      }
    };
  };

  var v,
      O = (v = [], function (t, e) {
    return v[t] = e, v.filter(Boolean).join("\n");
  });

  function S(t, e, n, r) {
    var o = n ? "" : r.css;
    if (t.styleSheet) t.styleSheet.cssText = O(e, o);else {
      var i = document.createTextNode(o),
          s = t.childNodes;
      s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(i, s[e]) : t.appendChild(i);
    }
  }

  function T(t, e) {
    var n = e.css,
        r = e.media;
    if (r && t.setAttribute("media", r), t.styleSheet) t.styleSheet.cssText = n;else {
      for (; t.firstChild;) {
        t.removeChild(t.firstChild);
      }

      t.appendChild(document.createTextNode(n));
    }
  }

  function E(t, e, n) {
    var r = n.css,
        o = n.sourceMap,
        i = void 0 === e.convertToAbsoluteUrls && o;
    (e.convertToAbsoluteUrls || i) && (r = d(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var s = new Blob([r], {
      type: "text/css"
    }),
        a = t.href;
    t.href = URL.createObjectURL(s), a && URL.revokeObjectURL(a);
  }
}, function (t, e) {
  t.exports = function (t) {
    var e = "undefined" != typeof window && window.location;
    if (!e) throw new Error("fixUrls requires window.location");
    if (!t || "string" != typeof t) return t;
    var n = e.protocol + "//" + e.host,
        r = n + e.pathname.replace(/\/[^\/]*$/, "/");
    return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
      var o,
          i = e.trim().replace(/^"(.*)"$/, function (t, e) {
        return e;
      }).replace(/^'(.*)'$/, function (t, e) {
        return e;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? t : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}]);